import React, { Component } from "react";
import DatePicker from "react-datepicker";
import { COMMON_PROPERTIES } from "properties/client";
import { parseISO } from "date-fns";
import "./date-style.css";
 
class CDate extends Component {
  constructor(props) {
    super(props);
console.log(props.value);
    this.state = { date: props.value || undefined };
  }
  setDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    d = [year, month, day].join("-");
    this.setState({ date });
    this.props.onChange(d);
  };
  componentDidMount() {
    if (this.props.value !== undefined) {
      this.setDate(this.props.value);
    }
  }
  render() {
    let { date } = this.state;
    const { formatType, format } = this.props.schema;
    let type = formatType;
    if (formatType === undefined) {
      if (format === "date") {
        type = COMMON_PROPERTIES.FORM_DATE_FORMAT;
      } else {
        type = COMMON_PROPERTIES.FORM_DATETIME_FORMAT;
      }
    }
    if (date !== undefined && date instanceof Date === false && !isNaN(date) && date !== null) {
      date = parseISO(date);
    } else if (this.props.value !== undefined && date !== null) {
      date = parseISO(this.props.value);
    } else if (date !== undefined && date instanceof Date === false && date !== null) {
      date = parseISO(date);
    }
    return (
      <div className="form-group field field-string">
        <DatePicker
          type="date"
          selected={date}
          onChange={(date) => this.setDate(date)}
          // timeIntervals={15}
          // timeCaption="time"
          showMonthDropdown
          showYearDropdown
          todayButton="Today"
          dateFormat={type}
        />
      </div>
    );
  }
}
 
export default CDate;